import axios from "axios";

import * as types from "./types";
import {
  API_URL, GOOGLE_CLIENT_ID,
  LOGIN_REDIRECT_URI,
} from "../common/constants";

// authorization actions

export const login = (loginData) => {
  const { email, password } = loginData;
  if (loginData.fullName) {
    //separate into firstName and lastName
    const [firstName, ...rest] = loginData.fullName.split(" ");
    const lastName = rest.join(" ");
    loginData.first_name = firstName;
    loginData.last_name = lastName;
    delete loginData.fullName;
  }
  //console.log("login", loginData);
  return async (dispatch) => {
    try {
      const url = `${API_URL}/auth/login`;
      const request = await axios.post(url, loginData);
      dispatch({
        type: types.LOGIN,
        payload: request?.data
      });
      return request?.data;
    } catch (error) {
      return false;
    }
  };
};

export const logingoogle = (idtoken) => {
  const props = {
    idtoken
  };
  const url = `${API_URL}/auth/logingoogleuser`;
  const request = axios.post(url, props);
  return {
    type: types.LOGIN,
    payload: request
  };
};

export const loginmicrosoft = (email, appid) => {
  const props = {
    email
  };
  const url = `${API_URL}/auth/loginmicrosoftuser`;
  const request = axios.post(url, props);
  return {
    type: types.LOGIN,
    payload: request
  };
};


export const checkToken = (token) => {
  const url = `${API_URL}/auth/valid/${token}`;
  const request = axios.get(url);
  return {
    type: types.CHECK_TOKEN,
    payload: request?.data
  };
};

export const loginToken = (token) => {
  return async (dispatch) => {
    try {
      const url = `${API_URL}/auth/login/token`;
      const request = await axios.post(url, { token });
      console.log("loginToken", request);
      dispatch({
        type: types.LOGIN,
        payload: request?.data
      });
    } catch (error) {
      return false;
    }
  };
};

export const logout = () => {
  return {
    type: types.LOGOUT
  };
};


// SSO

export const fetchGoogleProfile = async (token) => {
  // console.log('fetchGoogleProfile', token);
  let url = 'https://www.googleapis.com/oauth2/v1/userinfo';
  //url = `https://www.googleapis.com/oauth2/v3/tokeninfo?id_token=${token}`;
  //console.log('url', url);
  try {
    const response = await axios.get(url, {  
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      const userProfile = response.data;
      console.log('User Profile:', userProfile);
      return userProfile;
    } else {
      console.error('Failed to fetch user profile:', response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return null;
  }
};

export const fetchMicrosoftUser = (code) => {
  return async (dispatch) => {
    try {
      const url = `${API_URL}/auth/login/microsoft/${code}`;
      const request = await axios.post(url, { redirect_uri: LOGIN_REDIRECT_URI });
      console.log("fetchMicrosoftUser", request);
      dispatch({
        type: types.LOGIN,
        payload: request?.data
      });
      return request?.data;
    } catch (error) {
      return false;
    }
  };
};
